<template>
  <td :class="{ highlight }">
    <div class="service-date" v-if="date">
      <span v-if="dateClass === 'expired'">⚠️</span>
      <p class="date" :class="dateClass">{{ date }}</p>
    </div>
    <template v-else>
      <slot>{{ content }}</slot>
    </template>
  </td>
</template>

<script>
export default {
  name: "InventoryTableCell",
  props: ["content", "date", "highlight"],
  computed: {
    dateClass() {
      return this.getDateColor(this.date);
    },
  },
  methods: {
    getDateColor(date) {
      if (!date) return "";

      const currentDate = new Date();
      const targetDate = new Date(date.split(".").reverse().join("-"));

      const differenceInDaysValue = Math.floor(
        (targetDate - currentDate) / (1000 * 60 * 60 * 24)
      );

      if (differenceInDaysValue < 0) {
        return "expired"; // red + ⚠️
      } else if (differenceInDaysValue <= 3) {
        return "critical"; // red
      } else if (differenceInDaysValue <= 10) {
        return "warning"; // yellow
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.highlight {
  color: #3b86ff;
}
.service-date {
  align-items: center;
  display: flex;
  gap: 3px;

  span {
    font-size: 16px;
  }

  .date {
    border-radius: 3px;
    text-align: center;
    width: fit-content;

    &.warning {
      background: #ffd965 0% 0% no-repeat padding-box;
      border: 1px solid #bf930c;
      color: #4d4f5c;
      font-weight: bold;
      padding: 5px 10px;
    }

    &.expired,
    &.critical {
      background: #b43512 0% 0% no-repeat padding-box;
      border: 1px solid #741f08;
      color: #ffffff;
      font-weight: bold;
      padding: 5px 10px;
    }
  }
}
</style>
